<template>
  <div
    class="retake-ready"
    role="dialog"
    aria-modal="true"
    aria-labelledby="retake-ready-title"
    data-testid="retake-ready-prompt"
  >
    <div class="retake-ready__card">
      <h2 id="retake-ready-title" class="retake-ready__title">
        {{ $t('retakeSignedIn') }}
      </h2>
      <p class="retake-ready__body">
        {{ $t('retakeSignedInBody') }}
      </p>
      <ds-button
        variant="primary"
        size="touch"
        data-testid="retake-ready-open-button"
        @click="$emit('open')"
      >
        {{ $t('replayPractiseAgainButton') }}
      </ds-button>
      <ds-button
        variant="tertiary-deck"
        size="touch"
        data-testid="retake-ready-close-button"
        @click="$emit('close')"
      >
        {{ $t('replayLoginClose') }}
      </ds-button>
    </div>
  </div>
</template>

<script>
import Sentry, { featureTags } from '@/3rd-parties/sentry'
import { loadAudienceDesignSystem } from '../../utils/designSystemLoader'
import DsButton from './RetakeDsButton'

export default {
  components: { DsButton },
  mounted() {
    loadAudienceDesignSystem().catch((error) => {
      Sentry.captureException(error, {
        extra: { message: 'load design system failed' },
        tags: featureTags({ featureFlag: 'AHA-49118-replay', featureName: 'retake-ready-prompt', taskId: 'SEPA-22' }),
      })
    })
  },
}
</script>

<style lang="scss" scoped>
.retake-ready {
  position: fixed;
  inset: 0;
  z-index: 1001;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: theme('spacing.4');
  background-color: var(--aha-bg-overlay);
}

.retake-ready__card {
  display: flex;
  flex-direction: column;
  gap: theme('spacing.2');
  width: 100%;
  max-width: 28rem;
  padding: theme('spacing.6');
  box-sizing: border-box;
  background-color: theme('colors.base.0');
  border: 1px solid var(--aha-border-default);
  border-radius: theme('borderRadius.xl');
  color: theme('colors.ds.base');
  text-align: center;
}

.retake-ready__title {
  margin: 0;
  font-size: theme('fontSize.xl');
  font-weight: 600;
}

.retake-ready__body {
  margin: 0 0 theme('spacing.2');
  font-size: theme('fontSize.base');
}
</style>
